import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useLocale } from '../../LocaleProvider/rn'; // import BadActiveImg from '../../../assets/images/bad-active.png';
// import BadInactiveImg from '../../../assets/images/bad-inactive.png';
// import AverageActiveImg from '../../../assets/images/average-active.png';
// import AverageInactiveImg from '../../../assets/images/average-inactive.png';
// import GoodActiveImg from '../../../assets/images/good-active.png';
// import GoodInactiveImg from '../../../assets/images/good-inactive.png';

import { Button } from '../../Button/rn';
import Styles from './styles';
import { View, Text, TouchableOpacity } from 'react-native';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
import GoodInActiveV2Svg from '../../../assets/images/rn/GoodInActiveV2';
import GoodActiveV2Svg from '../../../assets/images/rn/GoodActiveV2';
import BadInActiveV2Svg from '../../../assets/images/rn/BadInActiveV2';
import BadActiveV2Svg from '../../../assets/images/rn/BadActiveV2';
import AverageInActiveV2Svg from '../../../assets/images/rn/AverageInActiveV2';
import AverageActiveV2Svg from '../../../assets/images/rn/AverageActiveV2';
var CSATFeedbackSelectorType;
(function (CSATFeedbackSelectorType) {
  CSATFeedbackSelectorType[CSATFeedbackSelectorType["ADD"] = 0] = "ADD";
  CSATFeedbackSelectorType[CSATFeedbackSelectorType["DELETE"] = 1] = "DELETE";
})(CSATFeedbackSelectorType || (CSATFeedbackSelectorType = {}));
var CSATFeedbackSelectorMode;
(function (CSATFeedbackSelectorMode) {
  CSATFeedbackSelectorMode["multiple"] = "multiple";
})(CSATFeedbackSelectorMode || (CSATFeedbackSelectorMode = {}));
var FeedbackType;
(function (FeedbackType) {
  FeedbackType[FeedbackType["GOOD"] = 1] = "GOOD";
  FeedbackType[FeedbackType["AVERAGE"] = 2] = "AVERAGE";
  FeedbackType[FeedbackType["BAD"] = 3] = "BAD";
})(FeedbackType || (FeedbackType = {}));
var InquiryResolvedOptions = [{
  label: 'label_yes_csat',
  value: 1
}, {
  label: 'label_no_csat',
  value: 2
}];
var CSATFeedbackOptionItem = function CSATFeedbackOptionItem(props) {
  var text = props.text,
    feedbackType = props.feedbackType,
    active = props.active,
    onClick = props.onClick;
  var FeedbackIcon = useMemo(function () {
    if (active) {
      switch (feedbackType) {
        case FeedbackType.AVERAGE:
          return AverageActiveV2Svg;
        case FeedbackType.BAD:
          return BadActiveV2Svg;
        case FeedbackType.GOOD:
          return GoodActiveV2Svg;
        default:
          return BadActiveV2Svg;
      }
    } else {
      switch (feedbackType) {
        case FeedbackType.AVERAGE:
          return AverageInActiveV2Svg;
        case FeedbackType.BAD:
          return BadInActiveV2Svg;
        case FeedbackType.GOOD:
          return GoodInActiveV2Svg;
        default:
          return BadInActiveV2Svg;
      }
    }
  }, [active, feedbackType]);
  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick(feedbackType);
  };
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: handleClick,
    style: Styles['csat-feedback-option-item']
  }, /*#__PURE__*/React.createElement(FeedbackIcon, {
    style: Styles['csat-feedback-option-item-feedback-icon']
  }), /*#__PURE__*/React.createElement(Text, {
    style: active ? Styles['csat-feedback-option-item-active-text'] : Styles['csat-feedback-option-item-inactive-text']
  }, text));
};
var CSATFeedbackSelector = function CSATFeedbackSelector(props) {
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var keyOptions = props.keyOptions,
    selectedKeys = props.selectedKeys,
    onSelect = props.onSelect,
    mode = props.mode,
    _props$containerStyle = props.containerStyle,
    containerStyle = _props$containerStyle === void 0 ? Styles['csat-feedback-key-item'] : _props$containerStyle,
    _props$rowStyle = props.rowStyle,
    rowStyle = _props$rowStyle === void 0 ? Styles['csat-feedback-key-item-row'] : _props$rowStyle,
    _props$activeTextStyl = props.activeTextStyle,
    activeTextStyle = _props$activeTextStyl === void 0 ? Styles['csat-feedback-key-item-active'] : _props$activeTextStyl,
    _props$inactiveTextSt = props.inactiveTextStyle,
    inactiveTextStyle = _props$inactiveTextSt === void 0 ? Styles['csat-feedback-key-item-inactive'] : _props$inactiveTextSt;
  var handleClickKey = function handleClickKey(option) {
    var newSelectedKeys = _toConsumableArray(selectedKeys);
    var csatFeedbackSelectorType = CSATFeedbackSelectorType.ADD;
    if (mode === CSATFeedbackSelectorMode.multiple) {
      if (selectedKeys.map(function (i) {
        return i.value;
      }).includes(option.value)) {
        newSelectedKeys = newSelectedKeys.filter(function (i) {
          return i.value !== option.value;
        });
        csatFeedbackSelectorType = CSATFeedbackSelectorType.DELETE;
      } else {
        newSelectedKeys.push(option);
        csatFeedbackSelectorType = CSATFeedbackSelectorType.ADD;
      }
    } else {
      newSelectedKeys = [option];
    }
    onSelect(option, newSelectedKeys, csatFeedbackSelectorType);
  }; // 满足 2 * 2 布局

  var renderKeyOptions = useMemo(function () {
    var options = [];
    keyOptions.forEach(function (option, index) {
      if (index % 2 === 0) {
        if (keyOptions[index + 1]) {
          options.push([option, keyOptions[index + 1]]);
        } else {
          options.push([option]);
        }
      }
    });
    return options;
  }, [keyOptions]);
  return /*#__PURE__*/React.createElement(View, {
    style: containerStyle
  }, renderKeyOptions.map(function (options, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: rowStyle,
      key: index
    }, options.map(function (option, idx) {
      return /*#__PURE__*/React.createElement(Text, {
        key: idx,
        onPress: function onPress() {
          return handleClickKey(option);
        },
        style: selectedKeys.map(function (i) {
          return i.value;
        }).includes(option.value) ? activeTextStyle : inactiveTextStyle
      }, trans(option.label));
    }));
  }));
};
export var CSATCardV2 = function CSATCardV2(props) {
  var onLeave = props.onLeave,
    onSubmit = props.onSubmit,
    onFeedbackOptionClick = props.onFeedbackOptionClick,
    _props$withResolved = props.withResolved,
    withResolved = _props$withResolved === void 0 ? false : _props$withResolved,
    feedbackKeyOptions = props.feedbackKeyOptions,
    componentTrackingData = props.componentTrackingData;
  var _useLocale2 = useLocale(),
    trans = _useLocale2.trans;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFeedback = _useState2[0],
    setSelectedFeedback = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFeedbackKeys = _useState4[0],
    setSelectedFeedbackKeys = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedInquiryResolve = _useState6[0],
    setSelectedInquiryResolve = _useState6[1];
  var selectedFeedbackRef = useRef();
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showInquiryResolved = _useState8[0],
    setShowInquiryResolved = _useState8[1];
  var submitDisabled = useMemo(function () {
    return !selectedFeedback;
  }, [selectedFeedback]);
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: props.componentTrackingData
    }),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    CSATCard_face = _useComponentTracking2.CSATCard_face,
    CSATCard_submit = _useComponentTracking2.CSATCard_submit,
    CSATCard_choose_reason = _useComponentTracking2.CSATCard_choose_reason,
    CSATCard_choose_resolution = _useComponentTracking2.CSATCard_choose_resolution,
    CSATCard_cancel_reason = _useComponentTracking2.CSATCard_cancel_reason;
  var handleClickFeedBackItem = function handleClickFeedBackItem(feedbackType) {
    var _CSATCard_face$tracki, _componentTrackingDat, _componentTrackingDat2;
    setSelectedFeedback(feedbackType);
    onFeedbackOptionClick === null || onFeedbackOptionClick === void 0 ? void 0 : onFeedbackOptionClick(feedbackType);
    (CSATCard_face === null || CSATCard_face === void 0 ? void 0 : CSATCard_face.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_face.trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (_CSATCard_face$tracki = CSATCard_face.trackingClick) === null || _CSATCard_face$tracki === void 0 ? void 0 : _CSATCard_face$tracki.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat = componentTrackingData.CSATCard_face) === null || _componentTrackingDat === void 0 ? void 0 : (_componentTrackingDat2 = _componentTrackingDat.trackingItemData) === null || _componentTrackingDat2 === void 0 ? void 0 : _componentTrackingDat2.call(_componentTrackingDat, {
        selectedFeedback: feedbackType
      }))
    }));
  };
  useLayoutEffect(function () {
    selectedFeedbackRef.current = selectedFeedback;
  }, [selectedFeedback]);
  var keyOptions = useMemo(function () {
    if (selectedFeedback === FeedbackType.BAD || selectedFeedback === FeedbackType.AVERAGE) {
      return feedbackKeyOptions;
    } else {
      return [];
    }
  }, [selectedFeedback]);
  var handleClickSubmit = function handleClickSubmit() {
    var _selectedInquiryResol;

    // 和旧csat reasonId顺序的逻辑保持一致
    var reasonIds = [];
    var reasons = [];
    var selectedFeedbackKeysValues = selectedFeedbackKeys.map(function (i) {
      return i.value;
    });
    feedbackKeyOptions.forEach(function (i) {
      if (selectedFeedbackKeysValues.includes(i.value)) {
        reasonIds.push(i.value);
        reasons.push(trans(i.label));
      }
    });
    var rateInfos = {
      rating: selectedFeedback ? selectedFeedback : undefined,
      resolved: (_selectedInquiryResol = selectedInquiryResolve[0]) === null || _selectedInquiryResol === void 0 ? void 0 : _selectedInquiryResol.value,
      reason: selectedFeedbackKeys.length ? reasons.join(',') : undefined,
      reason_id: selectedFeedbackKeys.length ? reasonIds.join(',') : undefined
    };
    if (selectedFeedback === FeedbackType.GOOD) {
      delete rateInfos.reason;
      delete rateInfos.reason_id;
    }
    onSubmit(rateInfos);
    (CSATCard_submit === null || CSATCard_submit === void 0 ? void 0 : CSATCard_submit.trackingClick) && tracker.click(CSATCard_submit.trackingClick);
  };
  var handleClickLeave = function handleClickLeave() {
    onLeave();
  }; // const csatCardTalking = useMemo(() => {
  //   if (selectedFeedback === FeedbackType.GOOD) {
  //     return trans('label_chatbot_feedback_content_good');
  //   } else if (selectedFeedback === FeedbackType.AVERAGE) {
  //     return trans('label_chatbot_feedback_content_avg');
  //   } else if (selectedFeedback === FeedbackType.BAD) {
  //     return trans('label_chatbot_feedback_content_bad');
  //   }
  //   return trans('label_chatbot_feedback_content_new');
  // }, [selectedFeedback]);

  useLayoutEffect(function () {
    if (selectedFeedback && withResolved) {
      setShowInquiryResolved(true);
    } else {
      setShowInquiryResolved(false);
    }
  }, [selectedFeedback, withResolved]);
  var handleSelectFeedbackKeys = function handleSelectFeedbackKeys(value, values, type) {
    setSelectedFeedbackKeys(values);
    var location = keyOptions.findIndex(function (i) {
      return i.value === value.value;
    });
    if (type === CSATFeedbackSelectorType.ADD) {
      var _CSATCard_choose_reas, _componentTrackingDat3, _componentTrackingDat4;
      (CSATCard_choose_reason === null || CSATCard_choose_reason === void 0 ? void 0 : CSATCard_choose_reason.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_choose_reason.trackingClick), {}, {
        data: _objectSpread(_objectSpread({}, (_CSATCard_choose_reas = CSATCard_choose_reason.trackingClick) === null || _CSATCard_choose_reas === void 0 ? void 0 : _CSATCard_choose_reas.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat3 = componentTrackingData.CSATCard_choose_reason) === null || _componentTrackingDat3 === void 0 ? void 0 : (_componentTrackingDat4 = _componentTrackingDat3.trackingItemData) === null || _componentTrackingDat4 === void 0 ? void 0 : _componentTrackingDat4.call(_componentTrackingDat3, _objectSpread(_objectSpread({}, value), {}, {
          location: location
        })))
      }));
    } else if (type === CSATFeedbackSelectorType.DELETE) {
      var _CSATCard_cancel_reas, _componentTrackingDat5, _componentTrackingDat6;
      (CSATCard_cancel_reason === null || CSATCard_cancel_reason === void 0 ? void 0 : CSATCard_cancel_reason.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_cancel_reason.trackingClick), {}, {
        data: _objectSpread(_objectSpread({}, (_CSATCard_cancel_reas = CSATCard_cancel_reason.trackingClick) === null || _CSATCard_cancel_reas === void 0 ? void 0 : _CSATCard_cancel_reas.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat5 = componentTrackingData.CSATCard_cancel_reason) === null || _componentTrackingDat5 === void 0 ? void 0 : (_componentTrackingDat6 = _componentTrackingDat5.trackingItemData) === null || _componentTrackingDat6 === void 0 ? void 0 : _componentTrackingDat6.call(_componentTrackingDat5, _objectSpread(_objectSpread({}, value), {}, {
          location: location
        })))
      }));
    }
  };
  var handleSelectFeedbackResolvedOptions = function handleSelectFeedbackResolvedOptions(value, values) {
    var _CSATCard_choose_reso, _componentTrackingDat7, _componentTrackingDat8;
    setSelectedInquiryResolve(values);
    (CSATCard_choose_resolution === null || CSATCard_choose_resolution === void 0 ? void 0 : CSATCard_choose_resolution.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, CSATCard_choose_resolution.trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, (_CSATCard_choose_reso = CSATCard_choose_resolution.trackingClick) === null || _CSATCard_choose_reso === void 0 ? void 0 : _CSATCard_choose_reso.data), componentTrackingData === null || componentTrackingData === void 0 ? void 0 : (_componentTrackingDat7 = componentTrackingData.CSATCard_choose_resolution) === null || _componentTrackingDat7 === void 0 ? void 0 : (_componentTrackingDat8 = _componentTrackingDat7.trackingItemData) === null || _componentTrackingDat8 === void 0 ? void 0 : _componentTrackingDat8.call(_componentTrackingDat7, {
        is_resolved: value.value
      }))
    }));
  };
  return /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card-header']
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles['csat-card-title']
  }, trans('label_chatbot_csat_title_new')), /*#__PURE__*/React.createElement(Text, {
    onPress: handleClickLeave,
    style: Styles['csat-card-leave-button']
  }, trans('label_chatbot_feedback_leave'))), /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card-feedback']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card-feedback-option']
  }, /*#__PURE__*/React.createElement(CSATFeedbackOptionItem, {
    text: trans('label_bad_csat'),
    feedbackType: FeedbackType.BAD,
    active: selectedFeedback === FeedbackType.BAD,
    onClick: handleClickFeedBackItem
  }), /*#__PURE__*/React.createElement(CSATFeedbackOptionItem, {
    text: trans('label_average_csat'),
    feedbackType: FeedbackType.AVERAGE,
    active: selectedFeedback === FeedbackType.AVERAGE,
    onClick: handleClickFeedBackItem
  }), /*#__PURE__*/React.createElement(CSATFeedbackOptionItem, {
    text: trans('label_good_csat'),
    feedbackType: FeedbackType.GOOD,
    active: selectedFeedback === FeedbackType.GOOD,
    onClick: handleClickFeedBackItem
  })), keyOptions !== null && keyOptions !== void 0 && keyOptions.length ? /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card-feedback-key']
  }, /*#__PURE__*/React.createElement(CSATFeedbackSelector, {
    keyOptions: keyOptions,
    selectedKeys: selectedFeedbackKeys,
    onSelect: handleSelectFeedbackKeys,
    mode: CSATFeedbackSelectorMode.multiple
  })) : null, showInquiryResolved ? /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card-feedback-inquiry']
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles['csat-card-feedback-inquiry-text']
  }, trans('label_chatbot_feedback_resolved_content')), /*#__PURE__*/React.createElement(CSATFeedbackSelector, {
    keyOptions: InquiryResolvedOptions,
    selectedKeys: selectedInquiryResolve,
    onSelect: handleSelectFeedbackResolvedOptions,
    containerStyle: Styles['inquiry-item-container'],
    rowStyle: Styles['inquiry-item-row'],
    activeTextStyle: Styles['inquiry-item-active-text'],
    inactiveTextStyle: Styles['inquiry-item-inactive-text']
  })) : null), /*#__PURE__*/React.createElement(View, {
    style: Styles['csat-card-submit']
  }, /*#__PURE__*/React.createElement(Button, {
    styles: {
      containerStyle: Styles['csat-card-submit-button']
    },
    type: "primary",
    onClick: handleClickSubmit,
    disabled: submitDisabled
  }, /*#__PURE__*/React.createElement(Text, {
    style: submitDisabled ? Styles['csat-card-submit-disabled-text'] : Styles['csat-card-submit-text']
  }, trans('label_submit_csat')))));
};